import { Icon } from "@/components/icons";
import { Flag } from "@/components/flag";
import { COUNTRY_LIST } from "@/components/country-picker";
import { countrySearchText } from "@/app/(app)/_lib/iso-countries";
import { SearchMultiSelectWithTags } from "@/components/search-multi-select-with-tags";
import { ADVERSE_MEDIA_COUNTRIES_STRICT_LABEL } from "@/src/services/search_configurations_service";
import { FilterCard, FilterLabel } from "./primitives";

const COUNTRY_ITEMS = COUNTRY_LIST.map((c) => ({
  name: c.name,
  value: c.iso,
  icon: <Flag iso={c.iso} size={16} desaturate={false} />,
  // Lets the search box find "United Kingdom" by "GB"/"GBR"/"UK".
  keywords: countrySearchText(c.iso),
}));

type CountryCardValueProps =
  | { selected: string[]; onChange: (next: string[]) => void; strictSelector?: false }
  | {
      /** `null` = "Strictly defined in the search". */
      selected: string[] | null;
      onChange: (next: string[] | null) => void;
      /** Adds the "Strictly defined in the search" option, which sets the value to `null`. */
      strictSelector: true;
    };

export function CountryCard({
  label = "Country",
  className = "flex-1 justify-center w-full",
  allSelector,
  disabled = false,
  labelSize = "tiny",
  ...value
}: CountryCardValueProps & {
  label?: string;
  className?: string;
  allSelector?: boolean;
  disabled?: boolean;
  labelSize?: "tiny" | "small";
}) {
  const common = {
    items: COUNTRY_ITEMS,
    placeholder: "Search countries",
    disabled,
    allSelector: allSelector
      ? { name: "Worldwide", icon: <Icon name="public" size={20} /> }
      : undefined,
  };
  return (
    <FilterCard className={className} disabled={disabled}>
      <FilterLabel size={labelSize}>{label}</FilterLabel>
      {value.strictSelector ? (
        <SearchMultiSelectWithTags
          {...common}
          selected={value.selected}
          onChange={value.onChange}
          nullSelector={{
            name: ADVERSE_MEDIA_COUNTRIES_STRICT_LABEL,
            icon: <Icon name="search" size={20} />,
          }}
        />
      ) : (
        <SearchMultiSelectWithTags
          {...common}
          selected={value.selected}
          onChange={value.onChange}
        />
      )}
    </FilterCard>
  );
}
